<template>
  <div
    v-if="data"
    class="invite_wrap team-page"
  >
    <div class="basic_wrap team-shell">
      <div class="red_top_bg team-header">
        <div
          class="back_left"
          @click="$router.back()"
        />
        <div class="big_tit">
          {{ $t('index.invite') }}
        </div>
        <div
          class="top_right"
          @click="$router.push('/teamhis')"
        >
          <van-icon
            name="share"
            size="18"
          />
        </div>
      </div>
      <div class="team-summary team-metrics">
        <div class="summary-grid">
          <div class="flex">
            <div class="items">
              <div class="text">
                {{ $t('shopds.totalrebate') }}
              </div>
              <div class="value">
                {{ data.countCommission }}
              </div>
            </div>
            <div class="items1 ml10">
              <div class="text">
                {{ $t('shopds.todayrebate') }}
              </div>
              <div class="value">
                0.00
              </div>
            </div>
          </div>
          <div class="flex mt20">
            <div class="items">
              <div class="text">
                {{ $t('shopds.totalp') }}
              </div>
              <div class="value">
                {{ countTeam }}
              </div>
            </div>
            <div class="items1 ml10">
              <div class="text">
                {{ $t('share.invest_sum') }}
              </div>
              <div class="value">
                {{ data.count_recharge }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="user_top bglight2">
				<div class="user_balance">
					<p>{{$t('share.commission')}}</p>
					<p>{{ utils_moneyMark() }}{{ data.countCommission }}</p>
				</div>
				<div class="user_team">
					<p>{{$t('share.team')}} <br/> <span>{{countTeam}}</span> ({{$t('share.people')}})</p>
					<p>{{$t('share.invest_sum')}} <br/> <span>{{ utils_moneyMark() }}{{ data.count_recharge }}</span></p>
				</div>
			</div> -->
			
      <div class="tabs team-tabs">
        <p
          :class="active==1?'active':''"
          @click="change(1)"
        >
          {{ $t('share.level1') }}({{ countTop1 }})
        </p>
        <p
          :class="active==2?'active':''"
          @click="change(2)"
        >
          {{ $t('share.level2') }}({{ countTop2 }})
        </p>
        <p
          :class="active==3?'active':''"
          @click="change(3)"
        >
          {{ $t('share.level3') }}({{ countTop3 }})
        </p>
      </div>
      <div class="list team-list">
        <van-empty
          v-if="listLength"
          :description="$t('item.noData')"
        />
        <div
          v-for="(i, index) in teamList"
          :key="index"
          class="item"
        >
          <p>{{ i.phone }}</p>
          <p>{{ i.time }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import Vue from 'vue';
	import {
		Empty
	} from 'vant';
	Vue.use(Empty);
	export default {
		name: "MyTeam",
		data() {
			return {
				data:null,
				countTeam:0,
				countTop1:0,
				countTop2:0,
				countTop3:0,
				active:1,
				teamList:[],
				listLength:true,
				qrcode: false,
			};
		},
		created() {
			this.$parent.footer('myteam', true);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/teamhis').then((r) => {
					this.data = r.data;
					r.data.top1.forEach(item => {
						item.phone = this.maskPhone(item.phone);
					});
					r.data.top2.forEach(item => {
						item.phone = this.maskPhone(item.phone);
					});
					r.data.top3.forEach(item => {
						item.phone = this.maskPhone(item.phone);
					});
					this.teamList = r.data.top1;
					if(r.data.top1.length==0){
						this.listLength = true;
					}else{
						this.listLength = false;
					}
					
					this.countTop1 = r.data.top1.length;
					this.countTop2 = r.data.top2.length;
					this.countTop3 = r.data.top3.length;
					this.countTeam = this.countTop1+this.countTop2+this.countTop3;
				});
			},
			maskPhone(phone) {
				const value = String(phone || '');
				if (value.length <= 8) {
					return value;
				}
				return value.substr(0, 3) + '***' + value.substr(value.length - 5, 5);
			},
			change(num){
				this.active = num;
				this.teamList = this.data[("top"+num)];
				if(this.teamList.length == 0){
					this.listLength = true;
				}else{
					this.listLength = false;
				}
			},
			copy() {
				this.$toast({
					background: "#07c160",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			downLoad(){
			    /*var that = this;
			     jsBridge.saveImageToAlbum(this.data.share_image_url, function(succ) {
			        that.$toast(succ ? "保存成功" : "保存失败：下载失败或没有相册使用权限");
			    }); */
			    this.downloadIamge(this.data.share_image_url,'share.jpg')
			},
			downloadIamge(imgsrc, name) { //下载图片地址和图片名
			    var image = new Image();
			    // 解决跨域 Canvas 污染问题
			    image.setAttribute("crossOrigin", "anonymous");
			    image.onload = function() {
			        var canvas = document.createElement("canvas");
			        canvas.width = image.width;
			        canvas.height = image.height;
			        var context = canvas.getContext("2d");
			        context.drawImage(image, 0, 0, image.width, image.height);
			        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
			
			        var a = document.createElement("a"); // 生成一个a元素
			        var event = new MouseEvent("click"); // 创建一个单击事件
			        a.download = name || "photo"; // 设置图片名称
			        a.href = url; // 将生成的URL设置为a.href属性
			        a.dispatchEvent(event); // 触发a的单击事件
			    };
			    image.src = imgsrc;
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		height: auto;
		padding-bottom: 10px;
		.big_tit {
			position: absolute;
		}
		.back_right{
			position: absolute;
			top: 3px;
			right: 3px;
		}
	}
	
	.user_top1{
		width: 96%;
		position: relative;
		// background: #3b2f5e;
		left: 2%;
		border-radius: 5px;
		padding: 15px 0;
		margin-top: 10px;
		 background-color: rgba(0, 0, 0, 0.3);
		.introduce {
		    height: 25px;
		    display: flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 18px;
		    line-height: 25px;
		    .line {
		        width: 36px;
		        height: 10px;
		    }
		
		    .tit {
		        margin: 0 12px;
		        font-weight: bold;
		    }
		
		    .left_line {
		        background: url(../images/user/left_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		
		    .right_line {
		        background: url(../images/user/right_icon.png) no-repeat center center;
		        background-size: 100% 100%;
		    }
		}
		.award_tip {
		    font-size: 14px;
		    line-height: 20px;
		    text-align: left;
		    margin: 3px 3vw;
			
		}
	}
	.user_top{
		width: 96%;
		position: relative;
		background: #FFF;
		left: 2%;
		border-radius: 5px;
		padding:  0;
		margin-top: 10px;
		.user_detail{
			display: flex;
			justify-content: space-between;
			text-align: center;
			.user_header {
				width: 70px;
				height: 70px;
				overflow: hidden;
				border-radius: 50%;
				position: absolute;
				top: -35px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			span{
				margin-left: 85px;
				font-size: 16px;
				font-weight: bold;
			}
		}
		.user_balance{
			text-align: center;
			margin-top: 10px;
			p:nth-child(1){
				font-size: 14px;
			}
			p:nth-child(2){
				margin-top: 10px;
				font-weight: bold;
				font-size: 18px;
				color: #FF0000;
			}
		}
		.user_team{
			display: flex;
			justify-content: space-between;
			text-align: center;
			p{
				width: 50%;
				margin-top: 20px;
				font-size: 14px;
			}
			p:nth-child(1){
				border-right: 1px #999 solid;
			}
			span{
				color: #FF0000;
				font-weight: bold;
			}
			
		}
		.user_share{
			display: flex;
			justify-content: space-between;
			margin: 20px 0 0px 0;
			font-size: 14px;
			p:nth-child(1){
				width: 70%;
				margin-left: 20px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 28px;
			}
			p:nth-child(2){
				text-align: center;
				width: 20%;
				background: #e7544d;
				color: #FFFFFF;
				padding: 6px 0px;
				border-radius: 5px;
				margin-right: 15px;
			}
		}
	}
	.tabs{
		display: flex;
		justify-content: space-between;
		text-align: center;
		width: 96%;
		margin-left: 2%;
		background: #FFF;
		height: 35px;
		border-radius: 5px;
		    margin-top: 10px;
		p{
			width: 28%;
			padding: 5px;
			border-radius: 5px;
			height: 25px;
			color: #FFFFFF;
			background:#2e4a9d ;
			margin: 5px;
		}
		.active{
			background:linear-gradient(90deg,#FDEBD5 0%,#FFF5EC 100%);
			color: #2e4a9d;
		}
	}
	.list{
		margin-top: 5px;
		width: 96%;
		margin-left: 2%;
		background: #FFFFFF;
		border-radius: 5px;
		height: 60vh;
		.item {
		    height: 52px;
		    line-height: 52px;
		    width: 314px;
		    margin: 0 auto;
		    display: flex;
		    justify-content: flex-start;
		    align-items: center;
		    border-bottom: 1px solid #E3E4E5;
			p:nth-child(1){
		        font-size: 13px;
		        color: #000;
		        margin-left: 8px;
		    }
			p:nth-child(2){
		        flex: 1;
		        margin-left: auto;
		        text-align: right;
		        font-size: 12px;
		        color: rgba(0, 0, 0, 0.4);
		    }
		}
	}
	.mask {
	    position: fixed;
	    top: 0;
	    right: 0;
	    left: 0;
	    bottom: 0;
	    background-color: rgba(0, 0, 0, 0.6);
	    z-index: 30;
	
	    .share_inner {
	        width: 230px;
			height: 280px;
	        position: absolute;
	        top: 60%;
	        left: 0;
	        right: 0;
	        margin: -232px auto 0 auto;
	        background: url(../images/user/share_bg.png) no-repeat center center;
	        background-size: 100% 100%;
			.earn{
				font-size: 32px;
				position: absolute;
				top: 112px;
				color: #fff;
				font-weight: bold;
				width: 100%;
				text-align: center;
			}
			.invite{
				font-size: 20px;
				position: absolute;
				top: 158px;
				color: #fff;
				width: 100%;
				text-align: center;
			}
			
	    }
	
	    .white_bg {
	        width: 160px;
			height: 160px;
	        background-color: #FFFFFF;
	        position: absolute;
	        top: 30px;
			left: 35px;
	        display: flex;
	        justify-content: center;
	        align-items: center;
	
	        img {
	            width: 143px;
	            height: 143px;
	        }
	    }
	
	    .basic_btn {
	        position: absolute;
	        left: 0;
	        right: 0;
	        margin: 0 auto;
	        top: 175px;
			height: 40px;
			line-height: 40px;
			font-size: 14px;
			width: 90%;
	    }
	}
	.nopermit{
		text-align: center;
		font-size: 12px;
		line-height: 25px;
		margin: 15px;
		.basic_btn{
			margin: 15px auto;
			width: 50%;
		}
	}
	.share{
	    overflow: hidden;
	    padding: 20px 2% 0;
		.share_box{
		    position: relative;
		    width: 100%;
		    height: 213px;
		    background-size: 100% 100%;
		    padding: 52px 0 0 31px;
		    box-sizing: border-box;
			// background: linear-gradient(270deg,#36333d, #746b0a);
			border-radius: 10px;
			background-color: rgba(0, 0, 0, 0.3);
			.copy{
			    width: 300px;
			    height: 44px;
			    padding: 0 5px 0 21px;
			    background: #fff;
			    border-radius: 10px;
			    box-sizing: border-box;
				.invite-link{
				    flex: 1;
				    font-size: 11px;
				    color: #2a2a2a;
				    word-break: break-all;
				    margin-right: 10px;
					line-height: 16px;
				    box-sizing: border-box;
				}
				.copy-btn{
				    flex-shrink: 0;
				    width: 75px;
				    height: 36px;
				    border-radius: 5px;
				    background: linear-gradient(1turn,#36333d, #746b0a);
				    font-size: 12px;
				    color: #fff;
				}
			}
		}
	}
	.flex-center {
	    display: flex;
	    justify-content: center;
	    align-items: center;
	}
	.invite-link{
	    flex: 1;
	    font-size: 11px;
	    color: #2a2a2a;
	    word-break: break-all;
	    margin-right: 10px;
		line-height: 16px;
	    box-sizing: border-box;
	}
	.share_box>div:nth-child(1){
	    width: 74px;
	    height: 74px;
	    position: absolute;
	    right: 11px;
	    top: -6px;
		img{
			height: 100%;
		}
	}
	.font-bold {
	    font-weight: 700;
	}
	.mb20 {
	    margin-bottom: 10px!important;
	}
	.c-white {
	}
	.ft28 {
	    font-size: 14px;
	}
	.mb50 {
	    margin-bottom: 26px!important;
	}
	.alcenter {
	    align-items: center;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.topBox{
	    background: linear-gradient(90deg,#FDEBD5 0%,#FFF5EC 100%);
		.topBoxChild{
		    padding: 21px 15px 19px 17px;
		    background: url(../images/user/teamBg.png) no-repeat;
		    background-size: 189.2px 172px;
		    background-position: right;
			.flex {
			    display: flex;
			}
			.items{
			    width: 35%;
			}
			.items1{
			    width: 45%;
			}
			.ml10 {
			    margin-left: 5.73333px;
			}
			.text {
			    color: #818181;
			    font-size: 14.9067px;
			}
			.mt20 {
			    margin-top: 12px;
			}
			.value{
			    font-weight: 700;
			    color: #234ba3;
			    font-size: 20.64px;
			    margin-top: 11.4667px;
			}
		}
	}
	.invite_wrap,
	.basic_wrap {
		min-height: 100vh;
	}
	.basic_wrap {
		box-sizing: border-box;
		padding-bottom: 100px;
		background: #f7f5f7 url('../images/ban1/ppbg.png') no-repeat center 56px / 100% auto;
	}
	.red_top_bg {
		height: 56px;
		padding: 0;
		border-radius: 0;
		background: linear-gradient(110deg, #ff4d72, #e31c5f 60%, #bd1e59);
		box-shadow: 0 8px 22px rgba(189, 30, 89, .14);
		.big_tit {
			top: 0;
			width: calc(100% - 108px);
			height: 56px;
			line-height: 56px;
			text-align: center;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-size: 17px;
			font-weight: 600;
		}
	}
	.back_left {
		position: absolute;
		z-index: 2;
		top: 0;
		left: 0;
		width: 48px;
		height: 56px;
		margin: 0;
		background-size: 20px auto;
		cursor: pointer;
	}
	.team-summary {
		margin: 20px 16px 18px;
		padding: 20px;
		border: 1px solid rgba(255, 255, 255, .18);
		border-radius: 18px;
		background: radial-gradient(circle at 12% 0%, #ff6382, #e31c5f 56%, #bd1e59);
		box-shadow: 0 16px 32px rgba(189, 30, 89, .18);
	}
	.summary-grid .flex {
		display: flex;
		gap: 14px;
	}
	.summary-grid .flex + .flex {
		margin-top: 18px;
		padding-top: 18px;
		border-top: 1px solid rgba(255, 255, 255, .22);
	}
	.summary-grid .items,
	.summary-grid .items1 {
		flex: 1;
		min-width: 0;
		margin: 0;
	}
	.summary-grid .text {
		color: rgba(255, 255, 255, .8);
		font-size: 12px;
		line-height: 1.4;
	}
	.summary-grid .value {
		margin-top: 8px;
		color: #fff;
		font-size: 23px;
		font-weight: 700;
		line-height: 1.2;
		word-break: break-all;
	}
	.tabs {
		box-sizing: border-box;
		display: flex;
		gap: 5px;
		width: calc(100% - 32px);
		height: auto;
		margin: 0 16px 12px;
		padding: 5px;
		border: 1px solid #f2e9ed;
		border-radius: 14px;
		background: #fff;
		box-shadow: 0 5px 18px rgba(50, 28, 42, .05);
	}
	.tabs p {
		box-sizing: border-box;
		flex: 1;
		min-width: 0;
		width: auto;
		height: auto;
		margin: 0;
		padding: 10px 3px;
		border-radius: 10px;
		background: transparent;
		color: #6e6870;
		font-size: 12px;
		font-weight: 600;
		line-height: 1.25;
		white-space: nowrap;
	}
	.tabs p.active {
		background: linear-gradient(100deg, #ff4d72, #d82162);
		box-shadow: 0 5px 12px rgba(227, 28, 95, .18);
		color: #fff;
	}
	.list {
		box-sizing: border-box;
		width: calc(100% - 32px);
		height: auto;
		min-height: 180px;
		margin: 0 16px;
		padding: 4px 16px;
		border: 1px solid #f2e9ed;
		border-radius: 16px;
		background: #fff;
		box-shadow: 0 8px 24px rgba(50, 28, 42, .06);
	}
	.list .item {
		box-sizing: border-box;
		width: 100%;
		height: auto;
		min-height: 58px;
		margin: 0;
		padding: 12px 0;
		gap: 8px;
		border-bottom: 1px solid #f1edf0;
		line-height: 1.3;
	}
	.list .item:last-child {
		border-bottom: 0;
	}
	.list .item p:first-child {
		min-width: 0;
		margin: 0;
		color: #27232a;
		font-size: 14px;
		font-weight: 600;
	}
	.list .item p:last-child {
		min-width: 0;
		margin: 0;
		color: #89828b;
		font-size: 12px;
		white-space: nowrap;
	}

	/* Team dashboard: consistent rem typography and a restrained financial visual system. */
	.team-page,
	.team-page .team-shell {
		min-height: 100vh;
	}

	.team-page {
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
	}

	.team-page .team-shell {
		padding-bottom: 1.7rem;
	}

	.team-page .team-header {
		position: relative;
		height: 1.4rem;
		padding: 0;
		border-radius: 0;
		background: rgba(21, 38, 60, .96);
		box-shadow: 0 .1rem .28rem rgba(16, 31, 49, .14);
	}

	.team-page .team-header .big_tit {
		top: 0;
		width: 100%;
		height: 1.4rem;
		padding: 0 1.2rem;
		box-sizing: border-box;
		color: #fff;
		font-size: .34rem;
		font-weight: 700;
		letter-spacing: .01rem;
		line-height: 1.4rem;
		text-align: center;
	}

	.team-page .team-header .back_left {
		z-index: 2;
		top: 0;
		left: .18rem;
		width: .88rem;
		height: 1.4rem;
		background: none;
	}

	.team-page .team-header .back_left::after {
		position: absolute;
		top: .5rem;
		left: .22rem;
		width: .24rem;
		height: .24rem;
		border-bottom: .04rem solid #fff;
		border-left: .04rem solid #fff;
		content: '';
		transform: rotate(45deg);
	}

	.team-page .team-metrics {
		position: relative;
		overflow: hidden;
		margin: .34rem .32rem .26rem;
		padding: .38rem;
		border: .01333rem solid rgba(255, 255, 255, .2);
		border-radius: .26rem;
		background: linear-gradient(122deg, #142942, #263f5c 67%, #592e45);
		box-shadow: 0 .2rem .4rem rgba(21, 37, 59, .2);
	}

	.team-page .team-metrics::after {
		position: absolute;
		top: -.7rem;
		right: -.5rem;
		width: 2.04rem;
		height: 2.04rem;
		border: .01333rem solid rgba(255, 255, 255, .16);
		border-radius: 50%;
		box-shadow: 0 0 0 .26rem rgba(255, 255, 255, .04);
		content: '';
	}

	.team-page .summary-grid {
		position: relative;
		z-index: 1;
	}

	.team-page .summary-grid .flex {
		display: flex;
		gap: .32rem;
	}

	.team-page .summary-grid .flex + .flex {
		margin-top: .3rem;
		padding-top: .3rem;
		border-top: .01333rem solid rgba(255, 255, 255, .18);
	}

	.team-page .summary-grid .items,
	.team-page .summary-grid .items1 {
		min-width: 0;
		flex: 1;
		margin: 0;
	}

	.team-page .summary-grid .text {
		color: rgba(255, 255, 255, .72);
		font-size: .25333rem;
		font-weight: 500;
		line-height: .36rem;
	}

	.team-page .summary-grid .value {
		margin-top: .1rem;
		overflow-wrap: anywhere;
		color: #fff;
		font-size: .48rem;
		font-weight: 700;
		letter-spacing: -.01333rem;
		line-height: .58rem;
	}

	.team-page .team-tabs {
		box-sizing: border-box;
		display: flex;
		gap: .08rem;
		width: auto;
		height: auto;
		margin: 0 .32rem .24rem;
		padding: .08rem;
		border: .01333rem solid rgba(255, 255, 255, .86);
		border-radius: .2rem;
		background: rgba(255, 255, 255, .95);
		box-shadow: 0 .12rem .26rem rgba(27, 43, 62, .09);
	}

	.team-page .team-tabs p {
		box-sizing: border-box;
		min-width: 0;
		flex: 1;
		height: .84rem;
		margin: 0;
		padding: 0 .06rem;
		border-radius: .14rem;
		background: transparent;
		color: #637287;
		font-size: .24rem;
		font-weight: 600;
		line-height: .84rem;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.team-page .team-tabs p.active {
		background: linear-gradient(100deg, #ff4d6c, #df2352);
		box-shadow: 0 .08rem .18rem rgba(223, 35, 82, .22);
		color: #fff;
	}

	.team-page .team-list {
		box-sizing: border-box;
		width: auto;
		min-height: 4.1rem;
		height: auto;
		margin: 0 .32rem;
		padding: .06rem .32rem;
		border: .01333rem solid rgba(255, 255, 255, .9);
		border-radius: .26rem;
		background: rgba(255, 255, 255, .96);
		box-shadow: 0 .18rem .4rem rgba(28, 42, 61, .12);
	}

	.team-page .team-list .item {
		display: flex;
		width: 100%;
		min-height: 1.08rem;
		height: auto;
		align-items: center;
		margin: 0;
		padding: .2rem 0;
		gap: .18rem;
		border-bottom: .01333rem solid #edf0f4;
		line-height: .36rem;
	}

	.team-page .team-list .item p:first-child {
		min-width: 0;
		flex: 1;
		margin: 0;
		overflow: hidden;
		color: #25364b;
		font-size: .28rem;
		font-weight: 600;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.team-page .team-list .item p:last-child {
		flex: 0 1 auto;
		margin: 0;
		color: #7c8999;
		font-size: .22667rem;
		white-space: nowrap;
	}

	.team-page .team-list /deep/ .van-empty {
		padding: .92rem .16rem;
	}

	.team-page .team-list /deep/ .van-empty__image {
		width: 2.28rem;
		height: 2.28rem;
	}

	.team-page .team-list /deep/ .van-empty__description {
		margin-top: .2rem;
		color: #8a96a5;
		font-size: .28rem;
		line-height: .4rem;
	}

	/* Account-centre visual language: calm photo backdrop, compact type and layered white cards. */
	.team-page,
	.team-page .team-shell {
		min-height: 100vh;
	}

	.team-page .team-shell {
		box-sizing: border-box;
		padding: 0 0 84px;
	}

	.team-page .team-header {
		margin: 0;
	}

	.team-page .team-metrics {
		position: relative;
		overflow: hidden;
		margin: 16px 16px 14px;
		padding: 0;
		border: 1px solid rgba(255, 255, 255, .96);
		border-radius: 16px;
		background: rgba(255, 255, 255, .96);
		box-shadow: 0 9px 24px rgba(36, 45, 58, .08);
	}

	.team-page .team-metrics::after {
		display: none;
	}

	.team-page .summary-grid::before {
		position: absolute;
		top: 16px;
		left: 16px;
		z-index: 2;
		width: 4px;
		height: 16px;
		border-radius: 3px;
		background: #ff385c;
		content: '';
	}

	.team-page .summary-grid .flex {
		display: flex;
		gap: 0;
	}

	.team-page .summary-grid .flex + .flex {
		margin-top: 0;
		padding-top: 0;
		border-top: 1px solid #f0edf0;
	}

	.team-page .summary-grid .items,
	.team-page .summary-grid .items1 {
		box-sizing: border-box;
		min-width: 0;
		min-height: 78px;
		margin: 0;
		padding: 16px;
	}

	.team-page .summary-grid .items1 {
		border-left: 1px solid #f0edf0;
	}

	.team-page .summary-grid .flex:first-child .items {
		padding-left: 28px;
	}

	.team-page .summary-grid .text {
		color: #6f6a72;
		font-size: 12px;
		font-weight: 500;
		line-height: 1.4;
	}

	.team-page .summary-grid .value {
		margin-top: 7px;
		overflow-wrap: anywhere;
		color: #222;
		font-size: 16px;
		font-weight: 700;
		letter-spacing: 0;
		line-height: 1.3;
	}

	.team-page .team-tabs {
		box-sizing: border-box;
		display: flex;
		gap: 4px;
		width: auto;
		height: auto;
		margin: 0 16px 14px;
		padding: 4px;
		border: 1px solid rgba(255, 255, 255, .96);
		border-radius: 14px;
		background: rgba(255, 255, 255, .96);
		box-shadow: 0 7px 18px rgba(36, 45, 58, .06);
	}

	.team-page .team-tabs p {
		height: 40px;
		padding: 0 4px;
		border-radius: 10px;
		color: #6b6670;
		font-size: 14px;
		font-weight: 600;
		line-height: 40px;
	}

	.team-page .team-tabs p.active {
		background: linear-gradient(100deg, #ff385c, #e31c5f);
		box-shadow: 0 5px 12px rgba(227, 28, 95, .18);
		color: #fff;
	}

	.team-page .team-list {
		box-sizing: border-box;
		width: auto;
		min-height: 250px;
		height: auto;
		margin: 0 16px;
		padding: 4px 16px;
		border: 1px solid rgba(255, 255, 255, .96);
		border-radius: 16px;
		background: rgba(255, 255, 255, .96);
		box-shadow: 0 8px 22px rgba(36, 45, 58, .07);
	}

	.team-page .team-list .item {
		min-height: 56px;
		padding: 12px 0;
		gap: 10px;
		border-bottom: 1px solid #f1edf0;
		line-height: 1.4;
	}

	.team-page .team-list .item p:first-child {
		font-size: 14px;
		line-height: 1.4;
	}

	.team-page .team-list .item p:last-child {
		color: #89828b;
		font-size: 12px;
		line-height: 1.4;
	}

	.team-page .team-list /deep/ .van-empty {
		padding: 68px 8px;
	}

	.team-page .team-list /deep/ .van-empty__image {
		width: 88px;
		height: 88px;
	}

	.team-page .team-list /deep/ .van-empty__description {
		margin-top: 10px;
		color: #89828b;
		font-size: 14px;
		line-height: 1.4;
	}
</style>
